import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, LoadingController, AlertController, Alert} from 'ionic-angular';
import { Item, Assignment, User } from '@providers/asset/index';

@Component({
  selector: 'page-detail-image',
  templateUrl: 'page.html'
})
export class DetailImagePage {

  url_image='https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/300px-No_image_available.svg.png';
  detail:any = {
    
  };
  detail_image : any={
    id : '',
    asset_image_desc : ''
  };
  imageWidth="100%";
  desc_edit = false;
  assign = 0;
  asset_document = false;
  assignment_result = false;
  akses : any={};

  rotationAmount = 0;
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public loadingCtrl : LoadingController,
    public alertCtrl : AlertController,
    public itemApi : Item,
    public assignmentApi : Assignment,
    public userApi : User
  ) {
    this.akses = this.userApi.akses;
    this.assign = this.navParams.get('assign');
    this.assignment_result = this.navParams.get('assignment_result');
    this.url_image = this.navParams.get('url_image');
    if(this.navParams.get('asset_document') != undefined){
      this.asset_document = this.navParams.get('asset_document');
    }
    if(this.navParams.get('detail')!=undefined){
      this.detail = this.navParams.get('detail');
      this.desc_edit = this.navParams.get('edit');
      console.log(this.detail);
      console.log(this.akses);
      console.log("assign => ", this.assign, "assign result => ", this.assignment_result);
    }
    this.getImages();
  }

  closeModal() {
    let data = { 'foo': 'bar' };
    this.viewCtrl.dismiss(data);
  }

  perbesar(){
    let n = parseInt(this.imageWidth)+10;
    this.imageWidth = n+"%";
  }

  perkecil(){
    let n = parseInt(this.imageWidth)-10;
    this.imageWidth = n+"%";
  }

  rotateImage(){
    var angle = this.rotationAmount +=90;
    if (this.rotationAmount == 360){
      this.rotationAmount = 0;
    }
    document.getElementById('image').style.transform='rotate('+angle+'deg)';
    console.log("rotate image => ",angle,"deg");
  }

  save(){

  }

  getImages(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {id: this.detail.id};
    let get : any;
    if(this.asset_document == false){
      if(this.assign==1){
        get = this.assignmentApi.getImages(params);
      }else{
        get = this.itemApi.getImages(params);
      }
      get.subscribe((resp:any) => {
          this.detail_image = resp.data[0];
          this.detail_image.asset_image_desc = resp.data[0].asset_image_desc;
        loading.dismiss();
      }, (err) => {
        loading.dismiss();
      });
    }else{
      loading.dismiss();
    }
  }

  showForm(){
    const prompt = this.alertCtrl.create({
      title: 'Deskripsi Gambar',
      inputs: [
        {
          name: 'deskripsi',
          placeholder: 'Masukan deskripsi gambar ...'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Save',
          handler: data => {
            let params:any={
              id : this.detail_image.id,
              asset_image_desc : data.deskripsi
            }
            let post : any;
            if(this.assign==1){
              post = this.assignmentApi.image_post(params);
            }else{
              post = this.itemApi.image_post(params);
            }
            post.subscribe((resp:any) => {
              this.getImages();
            });
            console.log('Saved clicked');
          }
        }
      ]
    });
    prompt.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/detail_image/page.ts